/* eslint-disable consistent-return */
/* eslint-disable no-useless-escape */
/* eslint-disable no-underscore-dangle */
/* eslint-disable radix */
'use strict';
var setdatalayer = require('../gtm/setdatalayer');
var gtmContainer = require('../gtm/container');
// lazyload is a function that is used later in this file. Why the linter doesn't realize that I have no idea
// eslint-disable-next-line no-unused-vars
var lazyload = require('lazyload');
var contentTile = require('../contentTile');

// Force a page reload on back/forward buttons so pagination history works
window.addEventListener('popstate', function () {
    window.location.reload();
});

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');

        $results.find('.' + $(this)[0].className.replace(/ /g, '.')).addClass('active');
    });

    updateDom($results, '.refinements');
    window.history.replaceState({}, '', $('.permalink').val());
    var collapsible = require('../components/collapsibleItem');
    collapsible.addAccessibilityButtons(true);
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements,
    };

    if ($results.find('.no-result-content').length) {
        $('.container.search-results').empty().html($results.html());
    } else {
        // Update DOM elements that do not require special handling
        [
            'h1',
            'h2.refinement-button-heading',
            '.breadcrumb',
            '.grid-header',
            '.header-bar',
            '.header.page-title',
            '.product-grid',
            '.show-more',
            '.filter-bar',
        ].forEach(function (selector) {
            updateDom($results, selector);
        });
    }

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
    $('.lazyload').lazyload();

    // Position content tiles after DOM update
    contentTile.positionContentInGrid();
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id + ', input[type="radio"].' + option.id).val(option.url);
    });
}

// hides background elements from mobile safari while filters are open
function disableBackgroundElements() {
    $(
        '.header-banner, header, .search-results-main-content, .search-mobile, footer, .back-to-top, .skip-link, .cid-cookie_hint'
    )
        .attr('aria-hidden', 'true')
        .attr('inert', '');
}

// restores hidden background elements
function enableBackgroundElements() {
    $(
        '.header-banner, header, .search-results-main-content, .search-mobile, footer, .back-to-top, .skip-link, .cid-cookie_hint'
    )
        .attr('aria-hidden', 'false')
        .removeAttr('inert');
}

function closeRefinements() {
    $('.refinement-bar, .modal-background').hide();
    $('.refinements .color-attribute .filter-selected').parent().removeAttr('aria-label');
    $('.refinements .filter-selected').removeClass('filter-selected');
}

function updateRefinements() {
    // Make selected price refinements stay selected in dropdowns
    var params = new URLSearchParams(window.location.search);

    if (params.get('pmin')) {
        $('.price-dropdown.min-price').addClass('selected');
        var pmin = parseInt(params.get('pmin'));
        var pmax = parseInt(params.get('pmax'));
        $('.price-dropdown.min-price option[value=' + pmin + ']').attr('selected', true);
        $('.price-dropdown.max-price option[value=' + pmax + ']').attr('selected', true);
    }

    var $refinments =
        $('.menu-toggleable-left').css('position') !== 'absolute'
            ? $('.refinement')
            : $('.refinement:not(.refinement-category)');
    // Variable to keep track of all the filters
    var numOfFilters = 0;
    $refinments.each(function () {
        var $this = $(this);
        // If there are selected refinements, leave the refinement group accordion open
        if ($this.find('span.selected').length > 0 || $this.find('.price-dropdown.min-price').hasClass('selected')) {
            numOfFilters += $this.find('span.selected').length;
            $this.removeClass('active');
            $this.find('.card-header').attr('aria-expanded', 'true');
        }
    });

    // Disable Reset Filters button if there are no selected filters
    var noSelectedFilters = $('.refinement:not(.refinement-category) .selected').length === 0;
    $('.reset-filters')
        .toggleClass('disabled', noSelectedFilters)
        .attr('tabindex', noSelectedFilters ? '-1' : '0')
        .attr('aria-disabled', noSelectedFilters ? 'true' : 'false');

    // Close the mobile filters menu
    closeRefinements();

    // Add selected filter class for refinement filters in mobile views
    if ($('.filter-results').is(':visible')) {
        $('.refinements .selected').addClass('filter-selected');

        // special aria-label for color refinements
        $('.refinements .color-attribute .selected').each(function () {
            var outerColorLink = $(this).parent();
            var colorText = outerColorLink.find('p').text().trim();
            outerColorLink.attr('aria-label', colorText + ', selected');
            outerColorLink.attr('aria-checked', true);
        });
    }

    if (window._lastFocus) {
        var lastFocusId = $(window._lastFocus).attr('id');
        // Use getElementById (exact id match) rather than a jQuery '#'-selector: the id can
        // contain characters like '&' or '.' that are invalid/meaningful in selector syntax.
        var clickedElement = lastFocusId ? $(document.getElementById(lastFocusId)) : $(window._lastFocus);
        clickedElement.parents('.refinement').find('button').focus();
    }
    $('#filter-results-button').children('span').append(`&nbsp;(${numOfFilters})`);
    $('.hide-filters-btn').on('click', hideFilters);
}
function syncFiltersUI() {
    var numOfFilters = $('span.selected').length;
    // if we are not on the search page, don't count the category in the count of refinements
    // if category refinement is hidden, it won't be included in the refinements, so don't subtract one in that case
    var categoryRefinement = $('.refinement.refinement-category');
    if (
        !window.location.href.includes('?q=') &&
        !window.location.href.includes('&q=') &&
        numOfFilters > 0 &&
        categoryRefinement.length
    ) {
        numOfFilters--;
    }
    if (numOfFilters <= 0) {
        $('.reset').css('display', 'none');
    } else {
        $('.reset').css('display', 'flex');
    }

    if (window.innerWidth <= 1204) {
        $('.search-results-main-content').addClass('col-md-14');
        $('#product-search-results').children('.row').css('display', 'flex');
        $('.refinements-to-hide').removeClass('hide-refinements');
        $('.search-results-main-content').removeClass('custom-search-adjusted');
        $('.grid-tile-container').removeClass('grid-tile-container-four');
        $('.hide-filters-btn').text('HIDE FILTERS');
    } else {
        var isHidden = $('.search-results-main-content').hasClass('custom-search-adjusted');

        if ($('.refinements-to-hide').length > 0) {
            $('.refinements-to-hide').toggleClass('hide-refinements', isHidden);
        }

        if (!isHidden) {
            $('.search-results-main-content').addClass('col-md-14');
            $('.search-results-main-content').addClass('offset-md-1');
            $('.search-results-main-content').removeClass('custom-search-adjusted');
            $('.grid-tile-container').removeClass('grid-tile-container-four');
            $('#product-search-results').children('.row').css('display', 'flex');
            $('.hide-sort-container').css('margin-left', '-1rem');
            $('.custom-select').addClass('ml-auto');
            $('.hide-filters-btn').text('HIDE FILTERS');
        } else {
            $('.search-results-main-content').removeClass('col-md-14');
            $('.search-results-main-content').addClass('custom-search-adjusted');
            $('.search-results-main-content').removeClass('offset-md-1');
            $('.grid-tile-container').addClass('grid-tile-container-four');
            $('#product-search-results').children('.row').css('display', 'flex');
            $('.custom-select').removeClass('ml-auto');
            $('.hide-filters-btn').text('SHOW FILTERS');
        }
    }
    $('.hide-filters-btn').append(`&nbsp;(${numOfFilters})`);
    $('.hide-filters-btn').off('click').on('click', hideFilters);
}

function hideFilters() {
    var $mainContent = $('.search-results-main-content');
    var isCurrentlyHidden = $mainContent.hasClass('custom-search-adjusted');
    
    // Toggle the master state
    if (isCurrentlyHidden) {
        $mainContent.removeClass('custom-search-adjusted');
    } else {
        $mainContent.addClass('custom-search-adjusted');
    }
    
    syncFiltersUI();
}

function hideFiltersSetup() {
    syncFiltersUI();
}

$('.hide-filters-btn').on('click', hideFilters);
$(window).on('resize', function () {
    if (window.innerWidth <= 1204) {
        var numOfFilters = $('span.selected').length;
        // if we are not on the search page, don't count the category in the count of refinements
        // if category refinement is hidden, it won't be included in the refinements, so don't subtract one in that case
        var categoryRefinement = $('.refinement.refinement-category');
        if (
            !window.location.href.includes('?q=') &&
            !window.location.href.includes('&q=') &&
            numOfFilters > 0 &&
            categoryRefinement.length
        ) {
            numOfFilters--;
        }
        $('.search-results-main-content').addClass('col-md-14');
        $('#product-search-results').children('.row').css('display', 'flex');
        $('.refinements-to-hide').removeClass('hide-refinements');
        $('.search-results-main-content').removeClass('custom-search-adjusted');
        $('.hide-filters-btn').text('HIDE FILTERS');
        $('.hide-filters-btn').append(`&nbsp;(${numOfFilters})`);
        $('.grid-tile-container').removeClass('grid-tile-container-four');
    } else {
        return;
    }
});
function updateCategoryName() {
    if (!window.location.href.includes('?q=') && !window.location.href.includes('&q=')) {
        // Used to get the full category name
        var categoryName = '';
        var counter = 1;
        if ($('.breadcrumb-item').length > 3) {
            counter = 2;
        }
        for (var i = counter; i < $('.breadcrumb-item').length; i++) {
            categoryName += $('.breadcrumb-item')[i].innerText + ' ';
            // Remove first category (Men's Woman's kid's accessories, brand) for certain cases
            if (
                $('.breadcrumb-item')[i].innerText.includes('Shop All') ||
                ($('.breadcrumb-item')[i].innerText.includes('Accessories') && i > 1) ||
                $('.breadcrumb-item')[i - 1].innerText.includes('Brands') ||
                ($('.breadcrumb-item')[i - 1].innerText.includes("Kids'") && i > 1)
            ) {
                categoryName = $('.breadcrumb-item')[i].innerText + ' ';
            }
        }
        $('#plp-search-heading-custom').text(categoryName);
    }
}

function setApplyFilterEnable() {
    // If there are no newly selected or deselected filters, disable the Apply Filters button
    var noNewlySelectedFilters =
        $('.filter-selected:not(.selected)').length + $('.selected:not(.filter-selected)').length === 0;

    // use class price-selected so button only is enabled when both dropdowns have a value
    var priceDropdownSelected =
        $('.price-dropdown.min-price').hasClass('price-selected') &&
        $('.price-dropdown.max-price').hasClass('price-selected');
    if (priceDropdownSelected) {
        noNewlySelectedFilters = false;
    }

    // Check if a sort rule has been selected
    var $refinementsContainer = $('.refinements');
    var sruleSelected = $refinementsContainer.data('srule');
    if (sruleSelected) {
        noNewlySelectedFilters = false;
    }

    $('.apply-filters')
        .toggleClass('disabled', noNewlySelectedFilters)
        .attr('tabindex', noNewlySelectedFilters ? '-1' : '0')
        .attr('aria-disabled', noNewlySelectedFilters ? 'true' : 'false');
}

// push product list data to gtm data
function gtmProductData() {
    gtmContainer.initPosition();

    var gtmdata = [];

    try {
        // SHOE-914 view all is reporting all productHits
        var gridContainer = $('.grid-tile-container'),
            gtmProducts = gridContainer.eq(0).find('.gtmproduct'),
            isViewAll = gridContainer.length > 0;
        if (isViewAll) {
            gtmProducts = gridContainer.eq(gridContainer.length - 1).find('.gtmproduct');
        }

        gtmProducts.each(function () {
            var data = $(this).data('object'),
                productName = data.name == null ? '' : data.name.replace(/\&#39;/g, "'"),
                category = data.category == null ? '' : data.category.replace(/\&#39;/g, "'"),
                brand = data.brand == null ? '' : data.brand.replace(/\&#39;/g, "'"),
                list = data.list == null ? '' : data.list.replace(/\&#39;/g, "'"),
                isCategory = $('.product-grid').find('.grid-footer-top').data('iscategory-search'),
                searchKeyword = $('.product-grid').find('.grid-footer-top').data('search-keyword');

            if (data.view == 'Category:') {
                gtmdata.push({
                    id: data.id,
                    name: productName,
                    price: $(this).data('price'),
                    brand: brand,
                    category: category,
                    position: $(this).data('position'),
                    list: isCategory == true ? data.view + list : 'Search:' + searchKeyword,
                });
            }
        });
        setdatalayer.ProductCarousel(gtmdata);
    } catch (ex) {
        console.log('GTM-Error:' + ex);
    }
}

/**
 * Traps focus within refinement menu
 * @param {element} jQuery - the element to trap focus on
 */
function trapMenuFocus(e) {
    var focusableEls = this.querySelectorAll(
            '.refinement-heading, .close, .refinement-actions button:not([aria-disabled=true])'
        ),
        firstFocusableEl = focusableEls[0],
        lastFocusableEl = focusableEls[focusableEls.length - 1],
        KEYCODE_TAB = 9;

    var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    var secondToLastEl = focusableEls[focusableEls.length - 2];

    if (!isTabPressed) {
        return;
    }

    if (e.shiftKey) {
        /* shift + tab */ if (document.activeElement === firstFocusableEl) {
            lastFocusableEl.focus();
            e.preventDefault();
        }
    } /* tab */ else if (document.activeElement.parentElement === secondToLastEl) {
        var lastElId = lastFocusableEl.id;
        lastElId = '#' + lastElId;
        var lastRefineTab = $(lastElId);
        lastRefineTab.focus();
        e.preventDefault();
    }
}

function focusFilter(filter) {
    // Use getElementById (exact id match) rather than a jQuery '#'-selector: the id can
    // contain characters like '&' or '.' that are invalid/meaningful in selector syntax.
    var $filter = $(document.getElementById(filter));
    if ($filter.length) {
        $filter.closest('.collapsible-sm').removeClass('active');
        $filter.closest('.refinement-heading').attr('aria-expanded', true);
        $filter.trigger('focus');
    }
}

// used to remove options higher than the selected value so that the "to" filter doesnt have access to values higher than the "from" filter
function showHideMinPriceFilter() {
    var selectedMax = $('.price-dropdown.max-price').val();
    if (selectedMax) {
        $('.price-dropdown.min-price option').each(function () {
            var $element = $(this);
            var elementValue = $element.val();
            if (elementValue < selectedMax) {
                $element.prop('disabled', false);
            } else {
                $element.prop('disabled', true);
            }
            $element.toggle($element.val() < selectedMax);
        });
    }
}

// used to remove options lower than the selected value so that the "to" filter doesnt have access to values lower than the "from" filter
function showHideMaxPriceFilter() {
    var selectedMin = $('.price-dropdown.min-price').val();
    if (selectedMin) {
        $('.price-dropdown.max-price option').each(function () {
            var $element = $(this);
            var elementValue = $element.val();
            if (elementValue > selectedMin) {
                $element.prop('disabled', false);
            } else {
                $element.prop('disabled', true);
            }
            $element.toggle($element.val() > selectedMin);
        });
    }
}

function removeDoublePriceSelect() {
    $('#refinement-id-price .price-refinement-link .selected').removeClass('selected');
    $('#refinement-id-price .price-refinement-link .filter-selected').removeClass('filter-selected');
}

function updateProductCount() {
    // update the number of products found at the top of the page above the refinements
    $('.num-items-span').text($('.product-grid .grid-footer .result-count > span').text());

    // update status ARIA live region for screen readers
    $('.num-items-sr.sr-only').text($('.product-grid .grid-footer .result-count > span').text());
}

function applyFiltersAjaxCall(url, $selectedFilter, callback, event) {
    $.spinner().start();
    $selectedFilter.trigger('search:filter', event);
    $.ajax({
        url: url,
        data: {
            page: $('.grid-footer').data('page-number'),
            selectedUrl: url,
        },
        method: 'GET',
        success: function (response) {
            parseResults(response);
            gtmProductData();
            updateRefinements();
            swatchOverride();
            hideFiltersSetup();
            updateProductCount();
            callback(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        },
    });
}

function swatchOverride() {
    $('.swatch-option').on('mouseover touchstart', function (e) {
        e.preventDefault();
        var tile = $(this).closest('.product-tile');
        tile.find('.tile-image').attr('src', this.dataset.productImg);
        tile.find('.product-tile-link').attr('href', this.href);
        tile.find('.product-name-link').attr('href', this.href);
        tile.find('.swatch-circle').removeClass('selected-plp');
        $(this).find('img.swatch-circle').addClass('selected-plp');
    });
}

function adjustRefinementCount() {
    // Added to either hide or remove the clear all button on load
    var numOfFilters = $('span.selected').length;
    // if we are not on the search page, don't count the category in the count of refinements
    // if category refinement is hidden, it won't be included in the refinements, so don't subtract one in that case
    var categoryRefinement = $('.refinement.refinement-category');
    if (
        !window.location.href.includes('?q=') &&
        !window.location.href.includes('&q=') &&
        numOfFilters > 0 &&
        categoryRefinement.length
    ) {
        numOfFilters--;
    }
    if (numOfFilters <= 0) {
        $('.reset').css('display', 'none');
    } else {
        $('.reset').css('display', 'flex');
    }
}

function handleShowMoreBtn(e) {
    var content = $(e.currentTarget).siblings('.content')[0];
    var showLessText = $(e.currentTarget).data('showLessText');
    var showMoreText = $(e.currentTarget).data('showMoreText');

    var initiallyVisibleRefinements = $(e.currentTarget).siblings('.original-refinement-values')[0];
    var allRefinements = $(e.currentTarget).siblings('.all-refinement-values')[0];
    var firstHiddenValueIdPrefix = $(initiallyVisibleRefinements).data('refinementIdPrefix');

    if ($(content).hasClass('initial-refinement-values')) {
        $(content).removeClass('initial-refinement-values');
        $(content).addClass('all-refinement-values');
        $(content).html($(allRefinements).html());
        $(e.currentTarget).text(showLessText);
        // focus first newly revealed refinement value
        var firstHiddenValueName = $(initiallyVisibleRefinements).data('firstHiddenValue');
        // Use getElementById (exact id match) rather than a jQuery '#'-selector: the id can
        // contain characters like '&' or '.' that are invalid/meaningful in selector syntax.
        var firstHiddenElement = document.getElementById(`${firstHiddenValueIdPrefix}-${firstHiddenValueName}`);
        if (firstHiddenElement) {
            firstHiddenElement.focus();
        }
    } else {
        $(content).removeClass('all-refinement-values');
        $(content).addClass('initial-refinement-values');
        $(content).html($(initiallyVisibleRefinements).html());
        $(e.currentTarget).text(showMoreText);

        var refinementDisplayName = $(initiallyVisibleRefinements).data('refinementDisplayName');
        // focus first refinement value in list
        var refinementGroupElement = document.getElementById(`refinement-id-${refinementDisplayName}`);
        if (refinementGroupElement) {
            var firstLink = refinementGroupElement.querySelector('li a');
            if (firstLink) {
                firstLink.focus();
            }
        }
    }
}

function updateFilterNumber() {
    var $refinments =
        $('.menu-toggleable-left').css('position') !== 'absolute'
            ? $('.refinement')
            : $('.refinement:not(.refinement-category)');
    // Variable to keep track of all the filters
    var numOfFilters = 0;
    $refinments.each(function () {
        var $this = $(this);
        // If there are selected refinements, add them to the total
        if ($this.find('span.selected').length > 0 || $this.find('.price-dropdown.min-price').hasClass('selected')) {
            numOfFilters += $this.find('span.selected').length;
        }
    });
    $('#filter-results-button').children('span').append(`&nbsp;(${numOfFilters})`);
}

$(document).ready(updateFilterNumber);
$(document).ready(updateCategoryName);
$(document).ajaxComplete(function () {
    hideFiltersSetup();
});

module.exports = {
    init: function () {
        $(document).ready(function () {
            swatchOverride();
            adjustRefinementCount();
            hideFiltersSetup();

            $(document).on('click', '.show-more-button', handleShowMoreBtn);
        });
    },

    filter: function () {
        $('.refinement-bar')[0].addEventListener('keydown', trapMenuFocus);
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').show();
            $('.refinements .refinement-category').addClass('collapsible-sm');
            $('.refinements .selected').addClass('filter-selected');
            // special aria-label for color refinements
            $('.refinements .color-attribute .selected').each(function () {
                var outerColorLink = $(this).parent();
                var colorText = outerColorLink.find('p').text().trim();
                outerColorLink.attr('aria-label', colorText + ', selected');
                outerColorLink.attr('aria-checked', true);
            });
            setApplyFilterEnable();
            setTimeout(function () {
                $('#sort-order-mobile input[type="radio"]').first().focus();
            }, 0);
            disableBackgroundElements();
        });
    },

    closeRefinments: function () {
        // Refinements close button
        $('.container').on('click', '.refinement-bar button.close, .modal-background', function () {
            closeRefinements();
            enableBackgroundElements();
            setTimeout(function () {
                $('#filter-results-button').focus();
            }, 0);
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            // eslint-disable-next-line no-unused-expressions
            !isMobile() && closeRefinements();
            enableBackgroundElements();
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.product-grid, .refinement-bar').on('change', '[name=sort-order], [name=sort-order-mobile]', function (e) {
            e.preventDefault();

            var $refinementsContainer = $('.refinements');
            var $selectedOption = this.tagName === 'SELECT' ? $(this).find('option:selected') : $(this);
            var sruleId = $selectedOption.data('id');

            // Store the sort selection for use when apply-filters is clicked
            $refinementsContainer.data('srule', sruleId);
            $refinementsContainer.data('srule-url', this.value);

            // On mobile (when filter button is visible), don't apply immediately
            var $filterResults = $('.filter-results');
            if ($filterResults.is(':visible')) {
                // Mark sort as selected for mobile view
                setApplyFilterEnable();
                return false;
            }

            // Desktop: apply immediately
            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    var $results = $(response);
                    var $grid = $results.find('.product-grid');
                    var $refinements = $results.find('.refinements');

                    $('.product-grid').empty().html($grid.html());
                    if ($refinements.length) {
                        $('.refinements').empty().html($refinements.html());
                    }

                    hideFiltersSetup();
                    gtmProductData();
                    swatchOverride();
                    updateRefinements();
                    $('.lazyload').lazyload();
                    contentTile.positionContentInGrid();
                    $.spinner().stop();
                    window.history.replaceState({}, '', $('.permalink').val());
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            e.preventDefault();
            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.show-more').remove();
                    $('.product-grid').append(response);
                    $('.grid-header:not(:first-child)').remove();
                    $('.grid-tile-container').eq(0).addClass('is-start');
                    updateSortOptions(response);
                    gtmProductData();
                    swatchOverride();
                    $('.lazyload').lazyload();
                    contentTile.positionContentInGrid();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });

        // Pagination
        $('.container').on('click', '.pagination a', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            $.spinner().start();
            $(this).trigger('search:showMore', e);
            var target = $(this);
            if (target.hasClass('view-all')) {
                $('.product-grid').addClass('view-all');
                $('.grid-tile-container').eq(0).addClass('is-start');
            } else {
                $('.product-grid').removeClass('view-all');
                $('.grid-tile-container').removeClass('is-start');
            }

            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    if (target.hasClass('view-all')) {
                        $('.product-grid').html(response);
                    } else if ($('.product-grid').hasClass('view-all')) {
                        $('.product-grid').append(response);
                    } else {
                        $('.product-grid').html(response);
                        $('.grid-tile-container').removeClass('is-start');
                    }
                    updateSortOptions(response);
                    $('.lazyload').lazyload();

                    if (!$('.product-grid').hasClass('view-all')) {
                        var page = $('.pagination').find('.current-page').data('page');
                        var pagecount = $('.pagination').find('.current-page').data('pagecount');
                        if (page > 1) {
                            $('.pagination').find('.previous-page').removeClass('disabled');
                            $('.pagination').find('.previous-page').attr('tabindex', '0');
                        } else {
                            $('.pagination').find('.previous-page').addClass('disabled');
                            $('.pagination').find('.previous-page').attr('tabindex', '-1');
                        }

                        if (page >= pagecount) {
                            $('.pagination').find('.next-page').addClass('disabled');
                            $('.pagination').find('.next-page').attr('tabindex', '-1');
                        } else {
                            $('.pagination').find('.next-page').removeClass('disabled');
                            $('.pagination').find('.next-page').attr('tabindex', '0');
                        }
                    }

                    gtmProductData();
                    swatchOverride();
                    contentTile.positionContentInGrid();

                    $.spinner().stop();
                    $('html, body').animate({ scrollTop: 0 });

                    var currentURL = new URL(window.location);

                    var updateGridURL = showMoreUrl;

                    var url =
                        currentURL.href.toString().split('?').splice(0, 1) +
                        '?' +
                        updateGridURL.split('?').splice(1, 1);

                    window.history.pushState({}, null, url);
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value deselection and reset click
        $('.container').on('click', '.filter-bar a.reset, .filter-value a, .swatch-filter a', function (e) {
            e.preventDefault();
            e.stopPropagation();

            applyFiltersAjaxCall(
                e.currentTarget.href,
                $(this),
                function () {
                    $('#filter-results-button').focus();
                },
                e
            );
        });

        // Handle refinement value selection
        $('.container').on('click', '.refinements li a', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $refinementsContainer = $('.refinements');
            $refinementsContainer.data('selectedFilter', $(this).attr('id'));
            var $this = $(this),
                $filterResults = $('.filter-results');

            // Toggle select behavior only when Filters menu is visible (i.e. mobile views)
            if ($filterResults.is(':visible')) {
                // Category and price refinement links behave like radio buttons; only one is active at a given time
                if ($this.hasClass('category-refinement-link')) {
                    $('.category-refinement-link span').removeClass('filter-selected');
                }
                if ($this.hasClass('price-refinement-link')) {
                    $('.price-refinement-link span').removeClass('filter-selected');
                    $('.price-dropdown .selected').removeClass('selected');
                }

                $this.find('span').toggleClass('filter-selected');

                // special aria-label for color refinements
                if ($this.parent().hasClass('color-attribute')) {
                    var colorText = $this.find('p').text().trim();
                    if ($this.find('span').hasClass('filter-selected')) {
                        $this.attr('aria-label', `${colorText}, selected`);
                        $this.attr('aria-checked', true);
                    } else {
                        $this.attr('aria-label', `${colorText}`);
                        $this.attr('aria-checked', false);
                    }
                }

                setApplyFilterEnable();
                return false;
            }

            applyFiltersAjaxCall(
                e.currentTarget.href,
                $this,
                function (response) {
                    // Update SEO by fetching it from the target category page and changing the page url state
                    var categoryLink = e.currentTarget;
                    $('.search-results .seo-content-slot').last().html($(response).find('.seo-content-slot').last());
                    history.replaceState(
                        { category: categoryLink.text.trim() },
                        categoryLink.text.trim(),
                        categoryLink.href
                    );

                    showHideMinPriceFilter();
                    showHideMaxPriceFilter();

                    updateCategoryName();
                    var selectedFilter = $refinementsContainer.data('selectedFilter');
                    focusFilter(selectedFilter);
                },
                e
            );
        });

        // enable spacebar for filters
        document.onkeypress = function (e) {
            e = e || window.event;
            var charCode = e.keyCode || e.which;
            if (charCode === 32 && $(document.activeElement).is('.container .refinements li a')) {
                e.preventDefault();
                $(e.target).click();
                return false;
            }
        };

        // handle price drop down select
        $(document).on('change', '.price-dropdown', function (e) {
            e.preventDefault();
            e.stopPropagation();

            // ensure that none of the radio boxes for price are checked
            removeDoublePriceSelect();

            var $refinementsContainer = $('.refinements');
            var $this = $(this);
            $refinementsContainer.data('selectedFilter', $(this).attr('id'));
            var $dropdownContainer = $this.closest('.price-dropdown');
            var min;
            var max;

            // make sure apply filter is enabled on mobile
            if ($('.filter-results').is(':visible')) {
                $this.addClass('price-selected');
                setApplyFilterEnable();
            }

            // hides/shows price options based on selections
            if ($dropdownContainer.hasClass('min-price')) {
                showHideMaxPriceFilter();
            } else {
                showHideMinPriceFilter();
            }

            min = $('.price-dropdown.min-price').val();
            max = $('.price-dropdown.max-price').val();

            // Make sure both values are selected before ajax call
            if (max === '') {
                $('.price-dropdown.max-price').trigger('click');
                return;
            } else if (min === '') {
                $('.price-dropdown.min-price').trigger('click');
                return;
            }

            // edit url to use new pmin and pmax
            var url = $dropdownContainer.attr('data-href');
            var urlObj = new URL(url, window.location.origin);
            urlObj.searchParams.set('pmin', min);
            urlObj.searchParams.set('pmax', max);
            url = urlObj.toString();

            // make ajax call
            if (url && !$('.filter-results').is(':visible')) {
                applyFiltersAjaxCall(
                    url,
                    $(this),
                    function (response) {
                        // Update SEO by fetching it from the target category page and changing the page url state
                        $('.search-results .seo-content-slot')
                            .last()
                            .html($(response).find('.seo-content-slot').last());
                        history.replaceState({ category: 'Price' }, 'Price', url);

                        showHideMinPriceFilter();
                        showHideMaxPriceFilter();

                        var selectedFilter = $refinementsContainer.data('selectedFilter');
                        focusFilter(selectedFilter);
                    },
                    e
                );
            }
        });

        // Apply Filters button click
        $('.container').on('click', '.apply-filters', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this),
                filterGroups = {},
                buildQuery = '',
                prefCount = 1,
                $refinementsContainer = $('.refinements'),
                searchURL = $refinementsContainer.data('url') + '?',
                searchString = $refinementsContainer.data('q'),
                $minPriceFromButtons = $('.price-dropdown.min-price .selected'),
                $maxPriceFromButtons = $('.price-dropdown.max-price .selected'),
                $minDropdownOption = $('.price-dropdown.min-price'),
                $maxDropdownOption = $('.price-dropdown.max-price');

            if (searchString) {
                buildQuery = 'q=' + searchString + '&';
            }
            var isCategoryRefinementShown = false;
            // Build the query string based on all refinement li's that contain the selected class.
            $('.refinement .filter-selected').each(function () {
                var $link = $(this).parent(),
                    filterData = {
                        id: $link.data('id'),
                        value: $link.data('value'),
                        isCategory: !!$link.data('category'),
                        isPrice: !!$link.data('price'),
                        min: $link.data('from'),
                        max: $link.data('to'),
                    };
                if (filterData.isCategory) {
                    // Only 1 category refinement is active so it is ok to put the name/value pair in the build query
                    buildQuery += 'cgid=' + filterData.value + '&';
                    isCategoryRefinementShown = true;
                } else if (
                    filterData.isPrice &&
                    $minPriceFromButtons.length === 0 &&
                    $maxPriceFromButtons.length === 0
                ) {
                    // Only 1 price refinement is active so it is ok to put the name/value pairs in the build query
                    buildQuery += 'pmin=' + filterData.min + '&';
                    buildQuery += 'pmax=' + filterData.max + '&';
                } else {
                    // Other refinement values are grouped based on their refinement IDs
                    // eslint-disable-next-line no-lonely-if
                    if (filterGroups[filterData.id]) {
                        filterGroups[filterData.id] += '|' + filterData.value;
                    } else {
                        filterGroups[filterData.id] = filterData.value;
                    }
                }
            });
            if (!isCategoryRefinementShown) {
                buildQuery += 'cgid=' + $('.category-id').val() + '&';
            }

            if ($minPriceFromButtons.length > 0 && $maxPriceFromButtons.length > 0) {
                // Only 1 price refinement is active so it is ok to put the name/value pairs in the build query
                buildQuery += 'pmin=' + $minPriceFromButtons.data('from') + '&';
                buildQuery += 'pmax=' + $maxPriceFromButtons.data('to') + '&';
            } else if ($minDropdownOption.val() !== '' && $maxDropdownOption.val() !== '') {
                // This is for when the dropdowns are used instead of the buttons
                buildQuery += 'pmin=' + $minDropdownOption.val() + '&';
                buildQuery += 'pmax=' + $maxDropdownOption.val() + '&';
            }

            // Append the other grouped refinement values to the build query
            Object.keys(filterGroups).forEach(function (filterId) {
                if (filterId != 'undefined') {
                    buildQuery +=
                        'prefn' +
                        prefCount +
                        '=' +
                        filterId +
                        '&' +
                        'prefv' +
                        prefCount +
                        '=' +
                        filterGroups[filterId] +
                        '&';
                    prefCount++;
                }
            });

            // Include sort rule if one was selected
            var srule = $refinementsContainer.data('srule');
            if (srule) {
                buildQuery += 'srule=' + srule + '&';
            }

            $.spinner().start();
            $this.trigger('search:filter', e);
            $.ajax({
                url: searchURL + buildQuery,
                data: {
                    selectedUrl: searchURL + buildQuery,
                },
                method: 'GET',
                success: function (response) {
                    $.spinner().stop();
                    $('.close').trigger('click');
                    parseResults(response);
                    gtmProductData();
                    updateRefinements();
                    swatchOverride();
                    $('#filter-results-button').focus();
                    $('.search-results .seo-content-slot').last().html($(response).find('.seo-content-slot').last());
                    history.replaceState({}, null, searchURL + buildQuery);
                    updateCategoryName();
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    },

    showTabs: function () {
        // Display tab results from the search
        $('.container').on(
            'shown.bs.tab',
            'a[href="#product-search-results"], a[href="#content-search-results-pane"]',
            function () {
                var carousels = require('../components/carousel');
                carousels.refresh();
            }
        );
    },

    handlePriceRangeDropdowns: function () {
        $(window).on('load', function () {
            showHideMinPriceFilter();
            showHideMaxPriceFilter();
        });
    },
};

function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
